export const configSettingsMenu = [
	{
		title: 'Enterprice Settings',
		link: '/bussines/edit'
	},
];